export enum VirtualMcVoiceType {
  Stephen = 'Stephen',
  Ruth = 'Ruth',
}
